import React from 'react';
import { Form, Input } from 'antd';

type Props = {
  form: any;
  label?: string;
  propertyName: string;
  value?: string;
  required?: boolean;
  placeholder?: string;
  formItemLayout: any;
  size?: any;
  formItemStyle?: any;
  disabled?: boolean;
  requiredMsg?: string;
  validatedMsg?: string;
  rules?: any[];
  validateLength: number;
  onChange?: any;
  autocomplete?: string;
  prefix?: React.ReactNode;
};

const InputEmail = (props: Props) => {
  const FormItem = Form.Item;
  const {
    label,
    propertyName,
    required,
    placeholder,
    formItemLayout,
    formItemStyle,
    size,
    disabled,
    requiredMsg,
    validatedMsg,
    onChange,
    prefix
  } = props;

  return (
    <FormItem
      hasFeedback
      label={label ?? ''}
      name={propertyName}
      {...formItemLayout}
      style={formItemStyle}
      rules={[
        { required, message: requiredMsg || `Please provide an ${label}` },
        {
          pattern: new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/),
          message: validatedMsg ? validatedMsg : 'This field only accepts a valid email address.'
        }
      ]}
    >
      <Input
        prefix={prefix}
        autoComplete={'off'}
        placeholder={placeholder}
        size={size}
        disabled={disabled}
        onChange={e => {
          onChange && onChange(e);
        }}
      />
    </FormItem>
  );
};
export default InputEmail;
